var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17l-18 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10l-3 -3l3 -3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7l18 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20l3 -3l-3 -3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.1acc5c861cad850b6029f0a099f71671.svg";
export { ForwardRef as ReactComponent };